export function normalizeEmbedOrigin(rawValue) {
  if (typeof rawValue !== "string") return null;

  const trimmed = rawValue.trim();
  if (!trimmed || trimmed.includes("*")) return null;

  let parsed;
  try {
    parsed = new URL(trimmed);
  } catch {
    return null;
  }

  if (!["http:", "https:"].includes(parsed.protocol)) return null;
  if (parsed.username || parsed.password) return null;
  if ((parsed.pathname || "/") !== "/") return null;
  if (parsed.search || parsed.hash) return null;

  return parsed.origin;
}

export function parseAllowedOriginsInput(input) {
  const lines = String(input || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const errors = [];
  const seen = new Set();
  const allowedOrigins = [];

  lines.forEach((line) => {
    const normalized = normalizeEmbedOrigin(line);
    if (!normalized) {
      errors.push(`Invalid origin: ${line}`);
      return;
    }
    if (seen.has(normalized)) return;
    seen.add(normalized);
    allowedOrigins.push(normalized);
  });

  return {
    allowedOrigins,
    errors,
  };
}

export function allowedOriginsToInput(origins) {
  if (!Array.isArray(origins) || origins.length === 0) return "";
  return origins.join("\n");
}

export function getParentOriginFromReferrer(referrer) {
  if (typeof referrer !== "string" || !referrer.trim()) return null;
  try {
    const parsed = new URL(referrer);
    if (!["http:", "https:"].includes(parsed.protocol)) return null;
    return parsed.origin;
  } catch {
    return null;
  }
}
